<template>
  <div class="content-wrapper">
    <div class="content-header row">
      <div class="card-body pt-0 pb-0">
        <div class="d-flex align-items-center">
          <div>
            <h3>Bem vindo <span style="font-size: 30px;">{{ userName }}</span></h3>
            <i>{{ companyName }}</i>
          </div>
        </div>
      </div>
    </div>
    <div class="content-overlay"></div>
    <div class="content-body">
      <!-- Stats Vertical Card -->
      <div class="row mt-2">
        <div class="col-xl-6 col-sm-6 col-12">
          <div class="card text-center">
            <div class="card-body cursor-pointer" v-on:click="goTo('/tickets')">
              <h2 class="font-weight-bolder">{{ myOpenTickets }}</h2>
              <p class="card-text">Total de Tickets na Pauta</p>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-sm-6 col-12">
          <div class="card text-center">
            <div class="card-body cursor-pointer" v-on:click="goTo('/tickets/92440719-8d94-4130-beba-3fc835188095')">
              <h2 class="font-weight-bolder">{{ myOpenTicketsInApproval }}</h2>
              <p class="card-text">Tickets Aguardando Aprovação</p>
            </div>
          </div>
        </div>
      </div>
      <!--/ Stats Vertical Card -->
    </div>
    <div class="content-body">
      <div class="row mt-2">
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between pb-0">
              <h4 class="card-title mb-1">Tickets em aprovação</h4>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th style="width: 100px;">Número</th>
                      <th>Título</th>
                      <th>Serviço</th>
                      <th>Fase atual</th>
                      <th>Qtde entregas</th>
                      <th>Próxima entrega</th>
                      <th>Entrega Combinada</th>
                      <th>Projeção de prazo</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="ticketsInApproval.length > 0">
                    <tr v-for="ticket in ticketsInApproval" :key="ticket._id" class="cursor-pointer" @click="goTo('/ticket/aprovacao/' + ticket._id)">
                      <td>{{ ticket.num }}</td>
                      <td>{{ ticket.name }}</td>
                      <td>{{ ticket.job_type_name }}</td>
                      <td>{{ ticket.phase_name }}</td>
                      <td>{{ ticket.approval_attempts }}</td>
                      <td>{{ format(ticket.first_approval_negotiated_at) }}</td>
                      <td>{{ format(ticket.phase_due_at) }}</td>
                      <td>{{ projection_local(ticket) }}</td>
                      <td>{{ ticket.status }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">Nenhum ticket em aprovação</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <customer-reports></customer-reports>
    </div>
  </div>
</template>

<script>
import { H } from 'hennig-common'
import CustomerReports from '../components/CustomerReports'

export default {
  name: 'CustomerHome',
  components: {
    'customer-reports': CustomerReports,
  },
  data () {
    return {
      myOpenTickets: 0,
      myOpenTicketsInApproval: 0,
      userName: window.auth.user_name,
      companyName: window.auth.company_name,
      ticketsInApproval: [],
    }
  },
  mounted () {
    H.rpc('Dashboard', 'HeaderCustomerData', [], (r) => {
      if (r) {
        this.myOpenTickets = r.myOpenTickets
        this.myOpenTicketsInApproval = r.myOpenTicketsInApproval
      }
    })

    H.rpc('Dashboard', 'CustomerTicketsInApproval', [], (r) => {
      if (r) {
        this.ticketsInApproval = r
      }
    })
  },
  methods: {
    goTo (url) {
      this.$router.push(url)
    },
    projection_local (row) {
      if (row.status !== 'Aberto') {return 'entregue'}
      if (!row.approval_diff) {return 'no prazo'}
      let diff = parseInt(row.approval_diff)
      const pos = diff < 0 ? ' a menos' : ' a mais'
      diff = Math.abs(diff)
      return diff + (diff === 1 ? ' dia' : ' dias') + pos
    }
  },
}
</script>

<style scoped>
.overx {
    overflow-x: scroll;
}
</style>
